type BuConfigKey =
    | 'REACT_APP_ENVIRONMENT'
    | 'REACT_APP_CONNECTION_TIME_OUT'
    | 'REACT_APP_HANDLE_TIMEZONE'
    | 'REACT_APP_DATE_FORMAT'
    | 'REACT_APP_TIME_FORMAT'
    | 'REACT_APP_DATE_TIME_FORMAT'
    | 'REACT_APP_DECIMAL_POINTER'
    | 'REACT_APP_THOUSAND_DIGIT_SYMBOL'
    | 'REACT_APP_SHOW_NOTIFICATION_COUNT'
    | 'REACT_APP_REFRESH_NOTIFICATION_INTERVAL'
    | 'REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE'
    | 'REACT_APP_DEFAULT_COUNTRY'
    | 'REACT_APP_DROPDOWN_LIMIT_COUNT'
    | 'REACT_APP_COUNTER_CHARGE_PREVIEW_MAX_COUNT'
    | 'REACT_APP_FIELD_ENABLE'
    | 'REACT_APP_RAIL_ENABLE'
    | 'REACT_APP_MESSAGE_BAR_TIMER'

export const getDefaultBuConfig = <T>(key: BuConfigKey): T | null => {
    try {
        const config = JSON.parse(localStorage.getItem("nBisBuConfig") || "null");
        return config?.[key] ?? null;
    } catch {
        return null;
    }
}

const parseMapString = (str: string): Record<string, boolean> => {
    if (!str || !str.startsWith('map[')) return {};
    const content = str.slice(4, -1);
    if (!content) return {};
    return content.split(' ').reduce((obj, pair) => {
        const [key, value] = pair.split(':');
        if (key && value) {
            obj[key] = value === 'true';
        }
        return obj;
    }, {} as Record<string, boolean>);
};
export const getDefaultBuConfigElement = <T>(firstKey: BuConfigKey, secondKey: string): T | null => {
    try {
        const config = JSON.parse(localStorage.getItem("nBisBuConfig") || "null");

        if (firstKey === "REACT_APP_FIELD_ENABLE") {
            const fieldEnableStr = config[firstKey];
            const fieldEnableObj = parseMapString(fieldEnableStr);
            return (fieldEnableObj[secondKey] as unknown as T) ?? null;
        }
        return config?.[firstKey]?.[secondKey] ?? null;
    } catch {
        return null;
    }
}
